import React from 'react';
import Row from 'react-bootstrap/Row';


const ReservationInfo = () => {
    return (
        <Row className='mb-5'>
            <h4>Reservation Information</h4>
            <p>
                Reservations can be made online or by calling our campground office. We offer both tent and RV camping options, and our friendly staff are always available to assist with any questions or special requests you may have. Don't miss out on the opportunity to experience the beauty of nature.
            </p>
        </Row>
    )

}

export default ReservationInfo;